import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { ModalContainer } from "../../../../../../common/components/modal_container";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useEffect } from "react";
import { FolhaPagamento } from "../../../../domain/models/folha_pagamento";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { CopiaFolhaPagamentoForm } from "../../../schemas/FolhaPagamento_lista/copia_folha_pagamento";

import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * CopiaFolhaPagamentoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  selectedFolhaPagamento: FolhaPagamento | null;
  hookForm: UseFormReturn<CopiaFolhaPagamentoForm>;
  onClose: () => void;
  onSubmit: (form: CopiaFolhaPagamentoForm) => void;
};

export const CopiaFolhaPagamentoModal = ({
  open,
  saving,
  selectedFolhaPagamento,
  hookForm,
  onClose,
  onSubmit,
}: Props) => {

  useEffect(() => {
    if (open) {
      if (selectedFolhaPagamento) {
        hookForm.reset({ dataCadastro: new Date() });
      }
    }
  }, [
    open,
    selectedFolhaPagamento,
    hookForm,
  ]);

  const handleSubmit = useCallback((form: any) => {
    if (!saving) onSubmit(form);
  }, [
    saving,
    onSubmit,
  ]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [
    saving,
    onClose,
  ]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>

      <DialogTitle>
        Cadastrar Folha de Pagamento
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <ModalContainer>
            <FormContainer title={"Informações"} arrangement="fullRow" border={false}>
              <>
                <DefaultFormInput
                  name='descricao'
                  label='Descrição'
                  multiline={true}
                  readOnly={saving}
                  rows={3}
                  required={true}
                  reactHookForm={hookForm} />

                <FormDatePickerInput
                  name='dataCadastro'
                  label='Data de Cadastro'
                  required={true}
                  reactHookForm={hookForm} />

                <FormDatePickerInput
                  name='dataPagamento'
                  label='Data de Pagamento'
                  required={true}
                  reactHookForm={hookForm} />

              </>
            </FormContainer>
          </ModalContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex px-4 pb-4 gap-4">
          <div></div>

          <div className="flex flex-row">
            <div className="flex flex-row gap-2">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={handleClose}>
                  Cancelar
                </h1>
              </div>

              <div className="w-[120px]">
                {saving ? (
                  <PrimaryButton
                    buttonColor="primary-green">
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    buttonColor="primary-green">
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}